module.exports = __webpack_public_path__ + "img/bm.ca26b6f.svg";